// القراءة بصوت عالٍ للأطفال الذين لا يقرؤون بعد (readAloud.nl.ts). النسخة العربية.
export const readAloudAr = {
    button: 'اقرأ بصوت عالٍ',
    stop: 'أوقف القراءة',
    task: 'اقرأ {task} بصوت عالٍ',
};
//# sourceMappingURL=readAloud.ar.js.map